import $ from 'jquery';

$(function () {
  window.initMap = function () {
    const mapElement = document.getElementById('single-event-map');
    const address = $(mapElement).data('address');

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address }, function (results, status) {
      if (status === 'OK') {
        const coordinates = results[0].geometry.location;

        const { AdvancedMarkerElement, PinElement } = google.maps.marker;

        const map = new google.maps.Map(mapElement, {
          center: coordinates,
          zoom: 13,
          mapId: '9f47dd00c611c0af' //from google cloud console - needed for advanced markers
        });

        const pin = new PinElement({
          background: "#004182",
          borderColor: "#ffffff",
          glyphColor: 'white',
        });

        const link = document.createElement('a');
        link.href = `https://www.google.com/maps/dir/?api=1&destination=${coordinates.lat()},${coordinates.lng()}`;
        link.target = '_blank';
        link.rel = 'noopener';
        link.style.textDecoration = 'none';
        link.appendChild(pin.element);

        new AdvancedMarkerElement({
          map,
          position: coordinates,
          content: link,
          title: 'Get Directions',
          gmpClickable: true
        });

      } else {
        console.error('Geocode was not successful for the following reason:', status);
      }
    });
  };

  if ($('#single-event-map').length) {
    const googleAPIKey = window.wlGlobalConfig.__gmap_key;
    const googleMapsAPI = 'https://maps.googleapis.com/maps/api/';

    // Create the script tag, set the appropriate attributes
    const script = document.createElement('script');
    script.src = `${googleMapsAPI}js?key=${googleAPIKey}&callback=initMap&loading=async&libraries=marker`;
    script.async = true;
    script.setAttribute('loading', 'async');
    document.head.appendChild(script);
  }
});
